import { useContext } from 'react';
import { UFrameworkContext, UFrameworkUpdateContext } from './context';

// Hook to access the entire state
export const useUFramework = (cb) => {
    return cb(useContext(UFrameworkContext));
}

// Hook to access the dispatch function
export const useDispatchUFramework = () => {
    return useContext(UFrameworkUpdateContext);
}

// Helper hooks for accessing specific parts of the state
export const useCommon = () => {
    const state = useContext(UFrameworkContext);
    return state.common;
}

// PIP module state hook
export const usePIP = () => {
    const state = useContext(UFrameworkContext);
    return state.pip;
}